module.exports = __webpack_public_path__ + "media/audio8.4fa786d5.mp3";